import { CircularProgress } from '@mui/material';
import styles from './styles.module.css';

const logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="150"
    fill="none"
    className={styles.logo}
    viewBox="0 0 63 75"
  >
    <mask
      id="mask0_2734_13670"
      style={{ maskType: 'luminance' }}
      width="63"
      height="75"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M62.985 0H0v74.695h62.985V0z"></path>
    </mask>
    <g mask="url(#mask0_2734_13670)">
      <path
        fill="url(#paint0_linear_2734_13670)"
        d="M48.332 40.724v-8.028a2.656 2.656 0 012.058-2.634h8.693a3.905 3.905 0 003.903-3.904V18.13a3.902 3.902 0 00-3.903-3.904H50.39a3.639 3.639 0 01-2.341-1.263 3.452 3.452 0 01-.53-.89V3.904A3.904 3.904 0 0043.615 0h-8.692a3.905 3.905 0 00-3.905 3.904v7.626c-.173.38-.42.72-.727 1.003a3.727 3.727 0 01-2.162.863c-.073.008-.156.038-.23.051h-8.662a3.901 3.901 0 00-3.904 3.904v8.027c0 .128.026.248.038.373-.027.098-.07.203-.087.296a3.385 3.385 0 01-.808 1.735 3.573 3.573 0 01-2.07 1.015H3.904A3.903 3.903 0 000 32.696v8.027a3.903 3.903 0 003.903 3.903h9.069c.64.159 1.219.506 1.66.997.393.482.639 1.067.71 1.685.009.047.03.108.04.152-.026.16-.042.322-.048.484v8.027a3.902 3.902 0 003.904 3.904h8.69c.083 0 .16-.019.241-.024.625.1 1.212.36 1.706.754.527.45.921 1.034 1.142 1.69v8.496a3.904 3.904 0 003.905 3.904h8.692a3.905 3.905 0 003.904-3.904v-8.496a3.355 3.355 0 012.87-2.264h8.694a3.905 3.905 0 003.903-3.905v-8.338a3.904 3.904 0 00-3.903-3.904H50.39a2.157 2.157 0 01-1.644-.793 2.092 2.092 0 01-.414-1.418v-.95zm-18.21-.216a3.904 3.904 0 01-3.903 3.905h-6.545a3.902 3.902 0 01-3.903-3.905v-6.542a3.904 3.904 0 013.903-3.904h6.544a3.904 3.904 0 013.903 3.904l.001 6.542zm16.1 15.096a3.903 3.903 0 01-3.904 3.905h-6.543a3.904 3.904 0 01-3.905-3.905v-6.548a3.904 3.904 0 013.905-3.905h6.541a3.905 3.905 0 013.905 3.905l.001 6.548zm0-30.183a3.903 3.903 0 01-3.904 3.904h-6.543a3.904 3.904 0 01-3.905-3.904v-6.55a3.904 3.904 0 013.905-3.905h6.541a3.905 3.905 0 013.905 3.904l.001 6.55z"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2734_13670"
        x1="31.493"
        x2="31.493"
        y1="0"
        y2="74.695"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5FC4AC"></stop>
        <stop offset="1" stopColor="#3477BD"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default function FirstLoader({ hideLogo = false }) {
  return (
    <div className={styles.wrapper}>
      {hideLogo ? <CircularProgress /> : logo}
    </div>
  );
}
